/**
 * 시중교재 정답 지원 여부
 * - 시중교재에만 적용되는 개념이지만, 다른 교재타입에서도 내려오는 값이므로 할당 시 한번 더 로직 타는 게 필요
 * - answerConfirmed가 false인 경우에만 정답 미지원
 * - true이거나 null이면 정답 지원
 */
export const normalizeAnswerConfirmed = (answerConfirmed: unknown) => {
  if (answerConfirmed === false) {
    return false
  }
  return true
}
